import { render, staticRenderFns } from "./groupFitnessDashboardVideos.vue?vue&type=template&id=5735a7aa&scoped=true"
import script from "./groupFitnessDashboardVideos.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardVideos.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardVideos.vue?vue&type=style&index=0&id=5735a7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735a7aa",
  null
  
)

export default component.exports